import { render, staticRenderFns } from "./PromocodeTemplate.vue?vue&type=template&id=105604d3&scoped=true&"
import script from "./PromocodeTemplate.vue?vue&type=script&lang=js&"
export * from "./PromocodeTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105604d3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('105604d3')) {
      api.createRecord('105604d3', component.options)
    } else {
      api.reload('105604d3', component.options)
    }
    module.hot.accept("./PromocodeTemplate.vue?vue&type=template&id=105604d3&scoped=true&", function () {
      api.rerender('105604d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/Templates/PromocodeTemplate.vue"
export default component.exports